import { Input } from '@chakra-ui/react'
import { FC, useState } from 'react'

import useFollowUpReabAlert from '@hook/alerts/use-followup-reab'

import LayoutToolsButton from '../../Components/Button'

const ActionFollowUpComentReabUpload: FC = () => {
  const [isLoading, setLoading] = useState(false)

  const { postUpload } = useFollowUpReabAlert()

  const handleClick = () => {
    const inputValue =
      document.querySelector<HTMLInputElement>('#supply-upload')

    inputValue.value = ''
    inputValue!.click()
  }

  return (
    <>
      <LayoutToolsButton
        label="Upload de arquivo comentários"
        isLoading={isLoading}
        loadingText="Fazendo upload"
        onClick={handleClick}
      />
      <Input
        id="supply-upload"
        d="none"
        type="file"
        accept="text/csv"
        onChange={event => {
          postUpload(event)
          setLoading(true)

          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
      />
    </>
  )
}

export default ActionFollowUpComentReabUpload
